module.exports = __webpack_public_path__ + "img/jira.4ff084e8.png";